import React, { useState } from 'react';
import { Figure, Div, weight } from 'globalStyle';
import { useSearchParam, useMediaQuery } from 'hooks';
import { TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import rechangeSuccess from 'assets/persons/goal-3.svg';
import computer from 'assets/persons/computer-2.svg';
import { useLocation } from 'wouter';
import { Dialog, DialogContent } from '@material-ui/core';
import arrowLeft from 'assets/icons/arrowLeftHeader.svg';
import closeIcon from 'assets/icons/closeIcon.svg';
import { formatNumber } from 'util/formatNumber';

export const RechargeStatus = () => {
  const [, setLocation] = useLocation();
  const recharge = useSearchParam('recharge');
  const amount = useSearchParam('amount');
  const [rechargeStatus, setRechargeStatus] = useState(() => {
    if (!recharge) return false;
    return true;
  });

  const handleClose = () => {
    setRechargeStatus(false);
    setLocation('?');
  };

  const isDesktop = useMediaQuery();
  return (
    <Dialog
      open={rechargeStatus}
      PaperProps={{
        style: { borderRadius: '25px', padding: isDesktop ? '30px' : '20px' },
      }}
      onClose={handleClose}
      maxWidth="md"
    >
      <DialogContent
        style={{
          width: isDesktop ? '500px' : '100%',
          padding: '0',
        }}
        align="center"
      >
        <Div isFlex justify="space-between">
          <Figure
            style={{
              width: '25px',
              height: '25px',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleClose();
            }}
          >
            <img src={arrowLeft} alt="arrowLeft" />
          </Figure>
          <Figure
            style={{ width: '15px', height: '15px', cursor: 'pointer' }}
            onClick={() => {
              handleClose();
            }}
          >
            <img
              src={closeIcon}
              alt="cerrar"
              style={{
                width: '100%',
                height: '100%',
              }}
            />
          </Figure>
        </Div>
        <Div>
          <Figure
            width={isDesktop ? '190px' : '150px'}
            height={isDesktop ? '190px' : '150px'}
            style={{ marginBottom: '30px' }}
          >
            <img
              src={
                rechargeStatus.transactionStatus === 'COMPLETED'
                  ? rechangeSuccess
                  : computer
              }
              alt="Recarga"
            />
          </Figure>
          <TextLight size={isDesktop ? 24 : 16} mb={20} weight={weight.BOLD}>
            Recarga en proceso
          </TextLight>
          <TextLight size={isDesktop ? 16 : 13} mb={10}>
            Estamos procesando tu recarga por
            <span style={{ fontWeight: weight.BOLD, marginLeft: '3px' }}>
              {formatNumber(amount)}
            </span>
            , en unos minutos podrás ver tu saldo actualizado en tu perfil.
          </TextLight>

          <TextLight size={isDesktop ? 16 : 13}>
            Si tienes algún problema puedes comunicarte con servicio al cliente.
          </TextLight>

          <Div isFlex margin="30px 0 0">
            <Hollow
              isSubmit
              onClick={handleClose}
              onColorType="primary"
              padding="10px 0"
              size="14"
              style={{
                borderRadius: '20px',
                width: isDesktop ? '330px' : '100%',
                height: isDesktop && '45px',
              }}
            >
              Entendido
            </Hollow>
          </Div>
        </Div>
      </DialogContent>
    </Dialog>
  );
};
